import styled from 'styled-components';

const FileDropzone = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(9.5rem, 1fr));
  grid-gap: 0.7rem;
  padding: 1rem;
  height: 15rem;
  overflow-y: auto;
`;

const FileDropzoneContainer = styled.div`
  position: relative;
  padding: 0.2rem;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.25);
  border-radius: 0.5rem;
`;

export { FileDropzone, FileDropzoneContainer };
